
import AppHeader from '@/components/AppHeader.vue' // @ is an alias to /src
import LoadingOverlay from './components/LoadingOverlay.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
  components: {
    LoadingOverlay,
    AppHeader,
  },
  data() {
    return {}
  },
  mounted() {
    const getTitle = () => {
      const hostname = window.location.hostname
      if (hostname.includes('fivestardev.com')) return 'Fivestar* Contributr'
      if (hostname.includes('simplesoft.net')) return 'Simplesoft Contributr'
      return 'Ingage Contributr'
    }
    document.title = getTitle()
  },
})
